import HostInquirer from './HostInquirer'

class SignalDecorator extends HostInquirer {
    constructor(context) {
        super(context)

        this.initiated = false
        this.elements = this.getAllElementsFromClassName('PicoSignal')

        this.defaults = {
            adBlocked: '',
            userEmail: '',
            userFirstName: '',
            userStatus: '',
            userTier: '',
            userVerified: false,
            userProduct: '',
        }

        this.adBlocked = this.defaults.adBlocked
        this.userEmail = this.defaults.userEmail
        this.userFirstName = this.defaults.userFirstName
        this.userStatus = this.defaults.userStatus
        this.userTier = this.defaults.userTier
        this.userVerified = this.defaults.userVerified
        this.userProduct = this.defaults.userProduct
    }

    init(payload) {
        if (!this.initiated) {
            this.initiated = true

            this.valueUpdater(payload)
        }
    }

    valueUpdater = (values = {}) => {
        if (!this.elements?.length) {
            return
        }

        Object.keys(values).forEach((key) => {
            const value = values[key]

            if (this[key] !== value) {
                this[key] = value || this.defaults[key]
            }
        })

        this.setDataAttributes()
    }

    setDataAttributes = () => {
        this.elements.forEach((element) => {
            element.setAttribute('data-pico-email', this.userEmail)
            element.setAttribute('data-pico-verified', this.userVerified)
            element.setAttribute('data-pico-first-name', this.userFirstName)
            element.setAttribute('data-pico-status', this.userStatus)
            element.setAttribute('data-pico-tier', this.userTier)
            element.setAttribute('data-pico-ad-blocked', this.adBlocked)
            element.setAttribute('data-pico-product', this.userProduct)
        })
    }
}

export default SignalDecorator
